import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Globale Basis-Styles
document.body.style.margin = "0";
document.body.style.fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
document.body.style.background = "#0f172a";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><App /></React.StrictMode>);
